export default function seoMetaData(state = {}, action) {
  if (action.type === 'SET_SEO_METADATA') {
    const { metaElementData = [] } = state;
    if (metaElementData.length > 0) {
      action.values.metaElementData = metaElementData;
    }
    const { values = {} } = action;
    return { ...state, ...values };
  }
  return state;
}
